import {Component, Prop, Vue} from "vue-property-decorator";
import {Notification, NOTIFICATION_MAX_CONTENT_SIZE_IN_BYTES} from "~/modules/notifications/lib/notification";
import {Columns} from "~/components/grid/columns";
import {Column} from "~/components/grid/column";
import {Label} from "~/components/forms/label";
import {XInput} from "~/components/forms/x-input";
import {RichTextEditor} from "~/components/forms/rich-text-editor";
import {NotificationMaxContentSize} from "~/modules/notifications/components/notification-max-content-size";

@Component
export class FlashNotificationEditor extends Vue {

  @Prop({type: Object, required: true}) notification: Notification;

  render() {
    return (
      <div>
        <Columns>
          <Column>
            <Label text="Titre *"/>
            <XInput v-model={this.notification.title}/>
          </Column>
        </Columns>
        <Columns>
          <Column>
            <Label text="Contenu"/>
            <button class="button m-b-10 is-small" onClick={() => this.$bubble("previewNotification", this.notification)}>Preview</button>
            <RichTextEditor v-model={this.notification.content}/>
            <NotificationMaxContentSize notification={this.notification}/>
          </Column>
        </Columns>
      </div>
    );
  }

}
// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-454eba0b/flash-notification-editor.tsx" });